import { ref, watch } from "vue";
import { useLocalStorage } from "@allwyn/storage/composables/use-storage";

const COOKIE_NAME = "isFixedHelpCollapsed";
const localStorageStore = useLocalStorage();

const isFixedHelpCollapsed = ref(localStorageStore.getItem<boolean>(COOKIE_NAME) ?? false);

watch(isFixedHelpCollapsed, (newIsFixedHelpCollapsed) => {
    if (newIsFixedHelpCollapsed) {
        localStorageStore.setItem(COOKIE_NAME, true, "essential");
    } else {
        localStorageStore.removeItem(COOKIE_NAME);
    }
});

export const useFixedHelpState = () => {
    return {
        isFixedHelpCollapsed,
    };
};
